import { Language } from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  styled,
  useTheme
} from '@mui/material';
import { PureLightTheme } from 'src/theme/schemes/PureLightTheme';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Dropdown } from 'src/models';
import { regularExpressions } from 'src/utils/properties';

export const GridContainer = styled(
  (props: {
    justifyContent?: string;
    backgroundColor?: string;
    width?: string;
    minHeight?: any;
    sx?: any;
    p?: any;
    pl?: any;
    pr?: any;
    rowSpacing?: any;
    columnSpacing?: any;
    borderRadius?: any;
    margin?: any;
    mt?: any;
    mr?: any;
    mb?: any;
    textAlign?: any;
    maxWidth?: any;
    height?: any;
    maxHeight?: any;
    direction?: any;
    alignItems?: any;
    spacing?: any;
  }) => <Grid container {...props} />
)({});

export const GridItem = styled(
  (props: {
    backgroundColor?: string;
    width?: string;
    maxWidth?: string;
    height?: any;
    minWidth?: string;
    sx?: any;
    p?: any;
    pt?: any;
    pl?: any;
    m?: any;
    mr?: any;
    ml?: any;
    mb?: any;
    mt?: any;
    margin?: any;
    xs?: any;
    md?: number;
    rowSpacing?: any;
    columnSpacing?: any;
    borderRadius?: any;
    textAlign?: any;
    component?: any;
    maxHeight?: any;
    minHeight?: any;
  }) => <Grid item xs={12} md={6} {...props} />
)({});

export const CardContainer = styled(
  (props: {
    backgroundColor?: string;
    width?: string;
    minWidth?: string;
    sx?: any;
    padding?: any;
    rowSpacing?: any;
    columnSpacing?: any;
    height?: any;
    maxHeight?: any;
  }) => (
    <Card
      sx={{
        borderRadius: '8px',
        [PureLightTheme.breakpoints.up('xs')]: {
          boxShadow: 'none',
          padding: '10px'
        },
        [PureLightTheme.breakpoints.up('sm')]: {
          padding: '25px'
        },
        [PureLightTheme.breakpoints.up('lg')]: {
          padding: '30px'
        },
        width: '100%'
      }}
      {...props}
    />
  )
)({});

export const ButtonComponent = styled(
  (props: {
    fullWidth?: boolean;
    variant?: any;
    backgroundColor?: string;
    width?: any;
    minWidth?: string;
    sx?: any;
    padding?: any;
    rowSpacing?: any;
    columnSpacing?: any;
    component?: any;
    to?: any;
    onClick?: () => void;
    disabled?: boolean;
  }) => (
    <Button
      sx={{
        borderRadius: '4px',
        backgroundColor: PureLightTheme.colors.alpha.orange[100],
        color: '#fff',
        position: 'relative',
        zIndex: 500
      }}
      {...props}
    />
  )
)({});

export const LoginButton = styled(
  (props: {
    sx?: any;
    type: any;
    width?: any;
    fullWidth?: boolean;
    variant?: any;
  }) => {
    const theme = useTheme();
    return (
      <Button
        variant="contained"
        sx={{
          fontFamily: 'Poppins',
          borderRadius: '24px',
          backgroundColor: theme.colors.alpha.orange[100],
          color: theme.colors.alpha.trueWhite[100],
          height: '48px',
          [theme.breakpoints.up('lg')]: {
            fontSize: '20px',
            borderRadius: '32px'
          },
          [theme.breakpoints.up('xl')]: {
            fontSize: '20px',
            height: '60px',
            borderRadius: '34px'
          }
        }}
        fullWidth
        {...props}
      />
    );
  }
)({});

export const MyAccountButton = styled(
  (props: {
    sx?: any;
    type: any;
    width?: any;
    fullWidth?: boolean;
    variant: any;
    component?: any;
    to?: any;
  }) => {
    const theme = useTheme();
    return (
      <Button
        sx={{
          fontFamily: 'Poppins',
          fontSize: '14px',
          borderRadius: '4px',
          backgroundColor: theme.colors.alpha.orange[100],
          color: theme.colors.alpha.trueWhite[100],
          height: '30px',
          fontWeight: 600
        }}
        {...props}
      />
    );
  }
)({});

export const StyledButton = styled(Button)(({ theme }) => ({
  fontSize: '20px',
  fontWeight: 600,
  fontFamily: 'Poppins',
  color: theme.colors.alpha.trueWhite[100],
  backgroundColor: '#FA7B17',
  borderRadius: '24px',
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px'
  }
}));

export const BottomButtonBoxStyle = styled(Box)(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  background: '#FFF',
  padding: '15px 15px 30px 15px',
  color: theme.colors.alpha.trueWhite[100]
}));

export const ImageCard = styled((props: { src: any; alt: any; sx?: any }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        background: '#2d3436',
        [theme.breakpoints.up('xs')]: {},
        [theme.breakpoints.up('sm')]: {},
        [theme.breakpoints.up('md')]: {},
        [theme.breakpoints.up('lg')]: {
          width: '380px',
          height: '350px'
        },
        [theme.breakpoints.up('xl')]: {
          width: '500px',
          height: '400px'
        }
      }}
      {...props}
    >
      <img
        src={props.src}
        alt={props.alt}
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain'
        }}
      />
    </Card>
  );
})({});

export const ImageCard2 = styled((props: { src: any; alt: any; sx?: any }) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        background: '#2d3436',
        [theme.breakpoints.up('xs')]: {},
        [theme.breakpoints.up('sm')]: {},
        [theme.breakpoints.up('md')]: {},
        [theme.breakpoints.up('lg')]: {
          width: '380px',
          height: '350px'
        },
        [theme.breakpoints.up('xl')]: {
          width: '500px',
          height: '400px'
        }
      }}
      {...props}
    >
      <img
        src={props.src}
        alt={props.alt}
        style={{
          height: '100%',
          width: '100%',
          objectFit: 'contain'
        }}
      />
    </Card>
  );
})({});

export const DescriptionGridItem = styled(GridItem)(({ theme }) => ({
  [theme.breakpoints.up('xs')]: {
    height: '180px'
  },
  [theme.breakpoints.up('sm')]: {
    minHeight: '80px'
  },
  [theme.breakpoints.up('md')]: {
    minHeight: '150px'
  },
  [theme.breakpoints.up('lg')]: {
    minHeight: '230px'
  },
  [theme.breakpoints.up('xl')]: {
    minHeight: '280px'
  }
}));

export const Title1 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '18px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '25px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '32px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '40px'
  }
}));

export const Title2 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '15px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '25px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '32px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '32px'
  }
}));

export const Title3 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 700,
  [theme.breakpoints.up('xs')]: {
    fontSize: '12px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '20px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '20px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '20px'
  }
}));

export const Title4 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 700,
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '16px'
  }
}));

export const Title5 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '10px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '20px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '20px'
  }
}));

export const Title6 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '25px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '32px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '32px'
  }
}));

export const Title7 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '20px'
  }
}));

export const Title8 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '32px'
  }
}));

export const Title9 = styled(Typography)(({ theme }) => ({
  color: '#343434',
  fontFamily: 'Poppins',
  fontWeight: 600,
  [theme.breakpoints.up('xs')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '24px'
  }
}));

export const Text1 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '16px',
  color: '#343434'
}));

export const Text2 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '14px',
  color: '#343434',
  [theme.breakpoints.up('xs')]: {
    fontSize: '12px'
  }
}));

export const Text3 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '12px',
  color: '#7E7E7E'
}));

export const Text4 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '14px',
  color: '#343434',
  fontWeight: 600
}));

export const Text5 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 400,
  lineHeight: '150%',
  textAlign: 'justify',
  [theme.breakpoints.up('xs')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '16px'
  }
}));

const Text5WithHtml = (props) => {
  const theme = useTheme();
  const { children } = props;

  return (
    <Typography
      fontFamily="Poppins"
      color="#343434"
      fontWeight={400}
      lineHeight="150%"
      textAlign="justify"
      sx={{
        [theme.breakpoints.up('xs')]: {
          fontSize: '14px'
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '16px'
        }
      }}
      dangerouslySetInnerHTML={{
        __html:
          children?.replace(regularExpressions.NEW_LINE_REGEX, '<br>') || ''
      }}
    />
  );
};

export const Text6 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '14px',
  color: '#343434',
  textAlign: 'left'
}));

export const Text7 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '14px',
  color: '#343434',
  textAlign: 'center'
}));

export const Text8 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 400,
  textAlign: 'justify',
  [theme.breakpoints.up('xs')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '16px'
  }
}));

export const Text9 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 600,
  textAlign: 'justify',
  [theme.breakpoints.up('xs')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '16px'
  }
}));

export const Text10 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 500,
  textAlign: 'justify',
  [theme.breakpoints.up('xs')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '20px'
  }
}));

export const Text11 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 700,
  textAlign: 'justify',
  [theme.breakpoints.up('xs')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '20px'
  }
}));

export const Text12 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 400,
  [theme.breakpoints.up('xs')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '16px'
  }
}));

export const Text13 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 300,
  fontSize: '12px'
}));

export const Text14 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#7E7E7E',
  fontWeight: 300,
  fontSize: '16px'
}));

export const Text15 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 400,
  fontSize: '14px',
  textAlign: 'justify'
}));

export const Text16 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '12px',
  color: '#343434'
}));

export const Text17 = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  fontSize: '16px',
  color: '#343434',
  textAlign: 'left'
}));

export const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '50%',
  bgcolor: 'background.paper',
  borderRadius: '5px',
  boxShadow: 24
};

export const viewOrEditProfileModalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80%',
  overFlowY: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '12px',
  p: 1
};

export const Logo = styled('img')(({ theme }) => ({
  alt: 'Logo Image',
  cursor: 'pointer',
  [theme.breakpoints.up('xs')]: {
    width: '100px',
    height: 'auto'
  },
  [theme.breakpoints.up('md')]: {
    width: '120px',
    height: 'auto'
  }
}));

export const LanguageIcon = styled(Language)(({ theme }) => ({
  color: theme.colors.alpha.orange[100],
  [theme.breakpoints.up('sm')]: {},
  [theme.breakpoints.up('md')]: {
    fontSize: '22px'
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '30px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '40px'
  }
}));

export const ModalCloseButton = styled(HighlightOffIcon)(({ theme }) => ({
  width: '40px',
  height: '40px',
  right: 0,
  borderRadius: '7px',
  border: '1px',
  color: 'rgba(52, 52, 52, 1)'
}));

export const LatexTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Poppins',
  color: '#343434',
  fontWeight: 400,
  textAlign: 'left',
  fontSize: '16px'
}));

export const MainContainer = styled(GridContainer)(({ theme }) => ({
  backgroundColor: 'rgba(87, 190, 255, 0.04)',
  width: '100%'
}));

export const VideoCard = styled(Card)(({ theme }) => ({
  background: '#2d3436',
  display: 'flex',
  justifyContent: 'center',
  margin: 'auto',
  [theme.breakpoints.up('xs')]: { width: '100px', minHeight: '100px' },
  [theme.breakpoints.up('sm')]: {
    width: '100%',
    minHeight: '130px'
  },
  [theme.breakpoints.up('md')]: {
    width: '100%',
    minHeight: '160px'
  },
  [theme.breakpoints.up('lg')]: {
    width: '100%',
    minHeight: '150px'
  },
  [theme.breakpoints.up('xl')]: {
    width: '100%',
    minHeight: '150px'
  }
}));

export const PaginationContainer = styled(GridContainer)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '10px'
}));

const ContainedButton = (props) => {
  const theme = useTheme();
  return (
    <Button
      {...props}
      variant="contained"
      sx={{
        borderRadius: '4px',
        color: theme.colors.alpha.trueWhite[100],
        background: theme.colors.alpha.orange[100],
        marginLeft: '10px',
        [theme.breakpoints.up('xs')]: {},
        [theme.breakpoints.down('sm')]: { width: '100%' },
        [theme.breakpoints.up('sm')]: {
          minWidth: '200px',
          height: '52px',
          fontSize: '20px'
        },

        '&:hover': {
          background: theme.colors.alpha.orange[70]
        }
      }}
    />
  );
};

const OutlinedButton = (props) => {
  const theme = useTheme();
  return (
    <Button
      {...props}
      variant="outlined"
      sx={{
        borderRadius: '4px',
        color: theme.colors.alpha.orange[100],
        [theme.breakpoints.up('xs')]: {},
        [theme.breakpoints.down('sm')]: {
          width: '100%'
        },
        [theme.breakpoints.up('sm')]: {
          minWidth: '200px',
          height: '52px',
          fontSize: '20px'
        },

        '&:hover': {
          background: theme.colors.alpha.orange[70]
        }
      }}
    />
  );
};

export const StyledTextInput = styled(TextField)(({ theme }) => ({
  justifyContent: 'center',
  fontFamily: 'Poppins',
  borderRadius: '12px',
  '& .MuiOutlinedInput-root': {
    '& > fieldset': { border: '1px solid #83CBFF' },
    '&::placeholder': {
      color: '#7E7E7E',
      fontSize: '16px'
    }
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '16px'
  }
}));

const FlexEndGridContainer = (props) => {
  return <GridContainer {...props} justifyContent="flex-end" />;
};

const CenterGridContainer = (props) => {
  return <GridContainer {...props} justifyContent="center" />;
};

const FlexCenterGrid = (props) => {
  return (
    <Grid
      {...props}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    />
  );
};

const AutoCompleteComponent = (props) => {
  return (
    <Autocomplete
      {...props}
      isOptionEqualToValue={(option: Dropdown, value: Dropdown | null) =>
        option.key === value?.key
      }
      disablePortal
      disableClearable
      fullWidth
      renderInput={(params) => (
        <StyledTextInput {...params} placeholder={props.placeholder} />
      )}
    />
  );
};

const CircularProgressForObject = (props) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export {
  OutlinedButton,
  ContainedButton,
  FlexEndGridContainer,
  CenterGridContainer,
  FlexCenterGrid,
  AutoCompleteComponent,
  CircularProgressForObject,
  Text5WithHtml
};
